import { QuestionCircleOutlined } from '@ant-design/icons';
import { FormItem, RadioGroupInput } from '@framework/form';
import { Trans, useTranslation } from '@framework/i18n';
import { Divider, Tooltip } from 'antd';
import { CitizenNationality } from '../../../routes/login/schema/CitizenRegisterSchema';

interface IUserNationalityFormProps {}

export function UserNationalityForm(props: IUserNationalityFormProps) {
  const { t } = useTranslation();

  return (
    <>
      <Divider>
        {t('user-registration-form.nationality', 'Nazionalità')}
      </Divider>
      <FormItem
        name="nationality"
        label={t('user-registration-form.nationality', 'Nazionalità')}
      >
        <RadioGroupInput
          name={'nationality'}
          options={[
            {
              label: t('user-profile-nationality.italy', 'Italiana'),
              value: CitizenNationality.Italy,
            },
            {
              label: (
                <Tooltip
                  color="#fff"
                  overlayInnerStyle={{ color: '#333' }}
                  title={
                    <Trans i18nKey="user-registration-form.nationaly-eidas-help">
                      È possibile consultare{' '}
                      <a
                        target="_blank"
                        href="https://www.eid.gov.it/en/eidas-network"
                        rel="noreferrer"
                      >
                        l&apos;elenco dei paesi che supportano il Login eIDAS
                        per l&apos;Italia
                      </a>
                      .
                    </Trans>
                  }
                >
                  {t('user-profile-nationality.EU', 'Paesi eIDAS')}
                  &nbsp;
                  <QuestionCircleOutlined style={{ fontSize: '0.8em' }} />
                </Tooltip>
              ),
              value: CitizenNationality.EU,
            },
            {
              label: t('user-profile-nationality.extra-EU', 'Altri Paesi'),
              value: CitizenNationality.ExtraEU,
            },
          ]}
        />
      </FormItem>
    </>
  );
}
